import './blog-grid.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initBlogProjects = (context) => {
  const blogProjectsSection = context.closest('.shopify-section');
  if (!blogProjectsSection) return;

  const tagContainer = blogProjectsSection.querySelector('.blog-grid__filters');

  new Swiper(tagContainer, {
    slidesPerView: "auto",
    on: {
      init: function () {
        updateScrollClasses(this);
      },
      slideChangeTransitionStart: function () {
        tagContainer.classList.add('scrolling');
      },
      slideChangeTransitionEnd: function () {
        tagContainer.classList.remove('scrolling');
        updateScrollClasses(this);
      }
    },
    navigation: {
      nextEl: tagContainer.querySelector('.swiper-button-next'),
      prevEl: tagContainer.querySelector('.swiper-button-prev'),
    },
  });

  function updateScrollClasses(swiper) {
    const tagContainer = swiper.el;
    tagContainer.classList.remove('scrolled-start', 'scrolled-end');
    if (swiper.isBeginning) {
      tagContainer.classList.add('scrolled-start');
    }
    if (swiper.isEnd) {
      tagContainer.classList.add('scrolled-end');
    }
  }


  const articlesWrapper = blogProjectsSection.querySelector(
    '.blog-grid__articles-wrapper',
  );
  const container = blogProjectsSection.querySelector(
    '.blog-grid__container',
  );
  if (!articlesWrapper || !container) return;

  container.classList.add('blog-grid__container--initialized');

  new Ajaxinate({
    container: '.blog-grid__articles-wrapper',
    pagination: '.blog-grid__pagination',
    method: 'click'
  });

  const content = blogProjectsSection.querySelector('.blog-grid__content');
  const filtersWrapper = blogProjectsSection.querySelector(
    '.blog-grid__filters',
  );
  if (!content || !filtersWrapper) return;
  filtersWrapper.querySelectorAll('.btn-chip[href]').forEach((filter) =>
    filter.addEventListener('click', (e) => {
      e.preventDefault();
      if (!filter.href) return;
      filter.blur();
      container.classList.add('loading');
      container.classList.remove('blog-grid__container--initialized');
      fetch(filter.href)
        .then((res) => {
          if (!res.ok) {
            container.classList.remove('loading');
            container.classList.add('blog-grid__container--initialized');
            var error = new Error(response.status);
            throw error;
          }

          return res.text();
        })
        .then((text) => {
          const newPage = new DOMParser().parseFromString(text, 'text/html');
          const newContent = newPage.querySelector('.blog-grid__content');
          if (!newContent) {
            container.classList.remove('loading');
            container.classList.add('blog-grid__container--initialized');
            return;
          }
          content.innerHTML = newContent.innerHTML;
          history.pushState(null, '', filter.href);
          newPage.querySelectorAll('.btn-chip[href]').forEach((newFilter) => {
            var oldFilter = filtersWrapper.querySelector(
              `.btn-chip:not([data-tag])`,
            );
            if (newFilter?.dataset?.tag) {
              oldFilter = filtersWrapper.querySelector(
                `[data-tag="${newFilter.dataset.tag}"]`,
              );
            }
            if (!oldFilter) return;
            oldFilter.setAttribute('data-active', newFilter.dataset.active);
            oldFilter.setAttribute('href', newFilter.href);
          });

          const articlesWrapper = blogProjectsSection.querySelector(
            '.blog-grid__articles-wrapper',
          );
          if (!articlesWrapper) {
            container.classList.remove('loading');
            container.classList.add('blog-grid__container--initialized');
            return;
          }

          new Ajaxinate({
            container: '.blog-grid__articles-wrapper',
            pagination: '.blog-grid__pagination',
            method: 'click'
          });

          container.classList.remove('loading');
          container.classList.add('blog-grid__container--initialized');
        });
    }),
  );
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.blog-grid__container'),
    (el) => {
      window.dAgency.initBlogProjects(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.blog-grid__container'),
      (el) => {
        window.dAgency.initBlogProjects(el);
      },
    );
  });
}
